export const performanceCategories: {
  id: string;
  title: {
    ja: PerformanceObject["category"];
    en: string;
  };
}[] = [
  { id: "section-0", title: { ja: "公演", en: "Performances" } },
  { id: "section-1", title: { ja: "映像作品", en: "Video works" } },
  { id: "section-2", title: { ja: "アウトリーチ", en: "Outreach" } },
];
